<app-shell-top-bar></app-shell-top-bar>
<router-outlet></router-outlet>
<app-loading [loading]="loading"></app-loading>
